var _extends = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];

    for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }

  return target;
};

function _objectWithoutProperties(obj, keys) {
  var target = {};

  for (var i in obj) {
    if (keys.indexOf(i) >= 0) continue;
    if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
    target[i] = obj[i];
  }

  return target;
}

import React from "react";

var SvgFuel = function SvgFuel(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return React.createElement("svg", _extends({
    viewBox: "0 0 18 20",
    ref: svgRef
  }, _extends({
    width: "1em",
    height: "1em"
  }, props)), React.createElement("title", null, title), React.createElement("defs", null, React.createElement("path", {
    id: "Fuel_svg__a",
    d: "M455.555 714.4c-.022-1.022-.666-1.444-1.244-1.6a1.38 1.38 0 0 0-.844.022v-7.177a.645.645 0 0 0-.645-.645h-9.11a.645.645 0 0 0-.645.645v17.844h-.822a.247.247 0 0 0-.245.244v1.023c0 .133.111.244.245.244h12.022a.247.247 0 0 0 .244-.244v-1.023a.247.247 0 0 0-.244-.244h-.822v-8.867c0-.133.044-.244.133-.333l.067-.067a.446.446 0 0 1 .244-.066c.222 0 .422.177.444.377v6.112a2.333 2.333 0 1 0 4.667 0l-.245-7.512c0-.666-.044-.888.356-1.2.289-.2.111-.777.044-1.022-.088-.422-.266-1.111-.466-1.489-1.111-2.377-3.622-3.355-3.622-3.355-.022-.022-.067-.022-.09-.045-.11-.044-.177-.044-.222-.022-.066 0-.133.067-.133.156v.266c0 .067.067.134.067.134.133.133.622.533.778.71.378.4.733.8.933 1.112.089.133.178.267.245.4.755 1.4.933 3.533.933 3.533l.022.578.245 7.444v.334c0 .622-.512 1.133-1.134 1.133-.622 0-1.156-.511-1.156-1.133zm-3.422-2.413a.574.574 0 0 1-.578.579h-6.644a.574.574 0 0 1-.578-.58v-5.185c0-.312.245-.579.578-.579h6.644c.312 0 .578.245.578.579z"
  })), React.createElement("use", {
    fill: "currentColor",
    xlinkHref: "#Fuel_svg__a",
    transform: "translate(-442 -705)"
  }));
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgFuel, _extends({
    svgRef: ref
  }, props));
});
export default ForwardRef;